'use client';
import { useEffect, useRef, useState } from 'react';

export default function CanaryBadge() {
  const [visible, setVisible] = useState(true);
  const dotRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot) return;

    let frame: number;
    let start: number;
    const duration = 3000;

    const animate = (ts: number) => {
      if (!start) start = ts;
      const elapsed = ts - start;
      const scale = 1 + Math.sin((elapsed / duration) * Math.PI * 4) * 0.5;
      const opacity = Math.max(0, 1 - elapsed / duration);
      dot.style.transform = `scale(${scale})`;
      dot.style.opacity = String(opacity);
      if (elapsed < duration) frame = requestAnimationFrame(animate);
      else dot.style.opacity = '0';
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        userSelect: 'none',
      }}
    >
      {/* Glow */}
      <div
        style={{
          position: 'absolute',
          inset: -4,
          borderRadius: 999,
          background: '#002854',
          filter: 'blur(8px)',
        }}
      />

      {/* Pill */}
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          background: '#002854',
          border: '1px solid rgba(252, 79, 22, 0.35)',
          borderRadius: 999,
          padding: '6px 12px',
          boxShadow: '0 4px 24px rgba(252, 79, 22, 0.15)',
        }}
      >
        {/* Dot */}
        <span style={{ position: 'relative', width: 8, height: 8, display: 'flex' }}>
          <span
            ref={dotRef}
            style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              background: '#fc4f16',
              transformOrigin: 'center',
            }}
          />
          <span
            style={{
              position: 'relative',
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: '#fc4f16',
              flexShrink: 0,
            }}
          />
        </span>

        {/* Label */}
        <span
          style={{
            fontFamily: 'monospace',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            color: '#fc4f16',
          }}
        >
          canary
        </span>

        {/* Dismiss */}
        <button
          onClick={() => setVisible(false)}
          aria-label="Dismiss"
          style={{
            marginLeft: 2,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#7a1e05',
            fontSize: 11,
            lineHeight: 1,
            padding: 0,
            transition: 'color 0.15s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#fc4f16')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#7a1e05')}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
